import { FaCode, FaMobileAlt, FaPaintBrush, FaTools } from "react-icons/fa";
 
 export  const infoServices = [
    {
      title: "Desarrollo Web",
      description: "Diseño y desarrollo de sitios web rápidos, responsivos y optimizados.",
      icon: <FaCode size={28} />,
    },
    {
      title: "Aplicaciones Móviles",
      description: "Apps híbridas con React Native, listas para Android y iOS.",
      icon: <FaMobileAlt size={28} />,
    },
    {
      title: "Diseño UI/UX",
      description: "Interfaz clara, moderna y orientada a una buena experiencia de usuario.",
      icon: <FaPaintBrush size={28} />,
    },
    {
      title: "Soporte y Mantenimiento",
      description: "Actualización y mejora continua de tus sistemas o sitios existentes.",
      icon: <FaTools size={28} />,
    },
  ];